import axios from "axios";

let authToken = null
if (typeof window !== "undefined") {
    if (localStorage.getItem('userDetails')) {
        const token = localStorage.token;
        authToken = `Bearer ${token}`;
    }
}
const instance = axios;

if (authToken) {
    instance.defaults.headers.common['Authorization'] = `${authToken}`;

    instance.interceptors.request.use((co) => {
        // if(co.headers['CLIENT-ID'] !== 'WAYABANK') {
        //   instance.defaults.headers.common['CLIENT-ID'] = 'WAYAPOS';
        //   instance.defaults.headers.common['CLIENT-TYPE'] = 'ADMIN';
        //   instance.defaults.headers.common["Authorization"] = `${authToken}`;
        // }
        return co;
    })

}

instance.defaults.headers.common['Content-Type'] = 'application/json';
// instance.defaults.headers.common['CLient-Id'] = 'WAYAPOS';
// instance.defaults.headers.common['Client-Type'] = 'ADMIN';

export default instance;